import { AWS_COLUMN_ID } from "../../../constants";
import IntegrationsAwsTableDropdownActionsCell from "./DropdownActionsCell";
import IntegrationsAwsTableNameCell from "./NameCell";
import IntegrationsAwsTableSpaceCell from "./SpaceCell";
import IntegrationsAwsTableTypeCell from "./TypeCell";

export const INTEGRATIONS_AWS_TABLE_CELLS = {
  [AWS_COLUMN_ID.TYPE]: IntegrationsAwsTableTypeCell,
  [AWS_COLUMN_ID.NAME]: IntegrationsAwsTableNameCell,
  [AWS_COLUMN_ID.SPACE]: IntegrationsAwsTableSpaceCell,
  [AWS_COLUMN_ID.DROPDOWN]: IntegrationsAwsTableDropdownActionsCell,
};
